import { inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TEAM_EVENT_BUS } from '@web-portal/domains/shared/event-bus';
import { Team } from '../../team/team.model';

/**
 * @internal
 * @description
 * Team store.
 */
export class TeamStore {
  private readonly _teams = signal<Team[]>([]);
  readonly teams = this._teams.asReadonly();
  private readonly _selectedTeam = signal<Team | null>(null);
  readonly selectedTeam = this._selectedTeam.asReadonly();

  private readonly teamEventBus = inject(TEAM_EVENT_BUS);

  constructor() {
    this.teamEventBus
      .on$<Team | Team[]>('[Teams] updated')
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        this.setTeams(event);
      });

    this.teamEventBus
      .on$<Team>('[Team] selected')
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        this._selectedTeam.set(event);
      });

    this.teamEventBus
      .on$<Team>('[Team] created')
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        this._teams.update(teams => [...teams, event]);
      });
  }

  private setTeams(teams: Team | Team[]): void {
    if (!Array.isArray(teams)) {
      this._teams.set([teams]);
      return;
    }

    this._teams.set(teams);
  }
}
